// extracted by mini-css-extract-plugin
module.exports = {"Version":"Version_Version__3Bgsh"};